import classNames from 'classnames';
export default function XIcon({ size = 16, color, className }) {
    return (<svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={classNames('fill-current', className, color)}>
      <path fillRule="evenodd" clipRule="evenodd" d="M12.43 3.527c.261.26.262.682.003.943L8.94 7.98l3.533 3.55a.667.667 0 1 1-.946.94L8 8.925 4.473 12.47a.667.667 0 1 1-.946-.94L7.06 7.98 3.567 4.47a.667.667 0 0 1 .946-.94L8 7.035l3.487-3.505a.667.667 0 0 1 .943-.003Z" fill="currentColor"/>
    </svg>);
}
